// size-chart.js

// Initialise the chain size chart inside a given container (the popup)
function initChainSizeChart(container) {
  const chart = container.querySelector('.size-chart--chains');
  if (!chart) {
    return;
  }

  const lengthButtons = Array.from(chart.querySelectorAll('[data-role="length-btn"]'));
  const neckButtons   = Array.from(chart.querySelectorAll('[data-role="neck-btn"]'));
  const images        = Array.from(chart.querySelectorAll('.size-chart__image-wrapper'));
  const currentLengthDisplay = chart.querySelector('[data-current-length]');
  const descEl = chart.querySelector('[data-current-description]');
  const neckHeightMap = {
    'thin':  '5ft 5" / 170cm',
    'broad': '6ft 4" / 195cm',
  };

  if (!lengthButtons.length || !neckButtons.length || !images.length) {
    return;
  }

  const normalize = (v) => String(v || '').trim().toLowerCase();

  let currentLength =
    (lengthButtons.find(b => b.classList.contains('is-active')) || lengthButtons[0])
      .dataset.length;

  let currentNeck =
    (neckButtons.find(b => b.classList.contains('is-active')) || neckButtons[0])
      .dataset.neck;

  function render() {
    lengthButtons.forEach(btn => {
      btn.classList.toggle(
        'is-active',
        normalize(btn.dataset.length) === normalize(currentLength)
      );
    });

    neckButtons.forEach(btn => {
      btn.classList.toggle(
        'is-active',
        normalize(btn.dataset.neck) === normalize(currentNeck)
      );
    });

    let found = false;
    let activeDescription = '';

    images.forEach(img => {
      const match =
        normalize(img.dataset.length) === normalize(currentLength) &&
        normalize(img.dataset.neck)   === normalize(currentNeck);

      img.classList.toggle('is-active', match);

      if (match) {
        found = true;
        activeDescription = img.dataset.description || '';
      }
    });

    if (!found && images.length) {
      images.forEach((img, i) => img.classList.toggle('is-active', i === 0));

      const first = images[0];
      currentLength = first.dataset.length || currentLength;
      currentNeck   = first.dataset.neck   || currentNeck;
      activeDescription = first.dataset.description || '';
    }

    if (currentLengthDisplay) {
      currentLengthDisplay.textContent = currentLength;
    }

    if (descEl) {
      descEl.textContent = activeDescription;
    }

    const heightEl = chart.querySelector('[data-model-height-value]');
    if (heightEl) {
      heightEl.textContent = neckHeightMap[normalize(currentNeck)] || '';
    }
  }

  lengthButtons.forEach(btn => {
    btn.addEventListener('click', function (e) {
      e.preventDefault();
      currentLength = this.dataset.length;
      render();
    });
  });

  neckButtons.forEach(btn => {
    btn.addEventListener('click', function (e) {
      e.preventDefault();
      currentNeck = this.dataset.neck;
      render();
    });
  });

  render();
}

document.addEventListener('DOMContentLoaded', function() {
  const popup = document.querySelector('[data-pdp-size-chart-target]');
  if (!popup) {
    return;
  }

  // Initialize chain chart functionality once
  initChainSizeChart(popup);

  // Open popup function
  function openPopup(productTags) {
    // If no product tags provided (product page context), just open normally
    if (!productTags) {
      popup.classList.remove('hidden');
      document.body.style.overflow = 'hidden';

      const hiddenContent = popup.querySelector('.size-chart-hidden-content');
      if (hiddenContent) {
        hiddenContent.style.display = 'block';
        hiddenContent.style.visibility = 'visible';
      }
      return;
    }

    // Cart drawer context - dynamically load content based on tags
    loadSizeChartForTags(productTags);
    
    popup.classList.remove('hidden');
    document.body.style.overflow = 'hidden';

    const hiddenContent = popup.querySelector('.size-chart-hidden-content');
    if (hiddenContent) {
      hiddenContent.style.display = 'block';
      hiddenContent.style.visibility = 'visible';
    }
  }

  // Close popup function
  function closePopup() {
    popup.classList.add('hidden');
    document.body.style.overflow = '';
  }

  // Load size chart content dynamically for cart drawer products
  function loadSizeChartForTags(tagsString) {
    const hiddenContent = popup.querySelector('.size-chart-hidden-content');
    if (!hiddenContent) return;

    const tags = tagsString.toLowerCase().split(',').map(t => t.trim());
    
    // Determine which chart type to show
    let chartHTML = '';
    
    if (tags.includes('chains') || tags.includes('bundles')) {
      chartHTML = getChainsChartHTML();
    } else if (tags.includes('bracelets')) {
      chartHTML = getBraceletsChartHTML();
    } else if (tags.includes('rings')) {
      chartHTML = getRingsChartHTML();
    } else if (tags.includes('earrings')) {
      chartHTML = getEarringsChartHTML();
    } else if (tags.includes('watches')) {
      chartHTML = getWatchesChartHTML();
    } else if (tags.includes('grillz')) {
      chartHTML = getGrillzChartHTML();
    }

    // Replace content
    hiddenContent.innerHTML = chartHTML;
    
    // Re-initialize chain chart if it's a chain product
    if (tags.includes('chains') || tags.includes('bundles')) {
      setTimeout(() => initChainSizeChart(popup), 50);
    }
  }

  // HTML templates for each chart type (for cart drawer)
  function getChainsChartHTML() {
    return `
      <div class="size-chart__heading">
        <button class="size-chart__close" data-size-chart-close aria-label="Close">&#x2715;</button>
        <div class="size-chart__header-text">Chain Size Guide</div>
      </div>
      <p>For a visual reference, check out our size guide below.</p>
      <div class="size-chart--chains" data-size-chart="chains">
        <div class="size-chart__current">
          <span class="size-chart__label">Lengths:</span>
          <span class="size-chart__value" data-current-length>18"</span>
          <span class="size-chart__description-chain">
            <span data-current-description>Unisex, popular for a subtle look</span>
          </span>
        </div>
        <div class="size-chart__buttons size-chart__buttons--length">
          <button type="button" class="size-chart__btn size-chart__btn--length is-active" data-role="length-btn" data-length='18"'>18"</button>
          <button type="button" class="size-chart__btn size-chart__btn--length" data-role="length-btn" data-length='20"'>20"</button>
          <button type="button" class="size-chart__btn size-chart__btn--length" data-role="length-btn" data-length='22"'>22"</button>
          <button type="button" class="size-chart__btn size-chart__btn--length" data-role="length-btn" data-length='24"'>24"</button>
        </div>
        <div class="size-chart__image-container">
          <div class="size-chart__image-wrapper is-active" data-length='18"' data-neck="Thin" data-description="Unisex, popular for a subtle look">
            <img src="https://cdn.shopify.com/s/files/1/0679/4461/2161/files/18-1.png?v=1763120427" loading="lazy" class="size-chart__image" alt="18 inch chain on thin neck">
          </div>
          <div class="size-chart__image-wrapper" data-length='20"' data-neck="Thin" data-description="MOST POPULAR">
            <img src="https://cdn.shopify.com/s/files/1/0679/4461/2161/files/20-1.png?v=1763120490" loading="lazy" class="size-chart__image" alt="20 inch chain on thin neck">
          </div>
          <div class="size-chart__image-wrapper" data-length='22"' data-neck="Thin" data-description="Relaxed, everyday fit">
            <img src="https://cdn.shopify.com/s/files/1/0679/4461/2161/files/22-1.png?v=1763120491" loading="lazy" class="size-chart__image" alt="22 inch chain">
          </div>
          <div class="size-chart__image-wrapper" data-length='24"' data-neck="Thin" data-description="Best for layering with other chains">
            <img src="https://cdn.shopify.com/s/files/1/0679/4461/2161/files/24-1.png?v=1763120491" loading="lazy" class="size-chart__image" alt="24 inch chain">
          </div>
          <div class="size-chart__image-wrapper" data-length='18"' data-neck="Broad" data-description="Unisex, popular for a subtle look">
            <img src="https://cdn.shopify.com/s/files/1/0679/4461/2161/files/18.png?v=1763120748" loading="lazy" class="size-chart__image" alt="18 inch chain on broad neck">
          </div>
          <div class="size-chart__image-wrapper" data-length='20"' data-neck="Broad" data-description="MOST POPULAR">
            <img src="https://cdn.shopify.com/s/files/1/0679/4461/2161/files/20.png?v=1763120749" loading="lazy" class="size-chart__image" alt="20 inch chain on broad neck">
          </div>
          <div class="size-chart__image-wrapper" data-length='22"' data-neck="Broad" data-description="Relaxed, everyday fit">
            <img src="https://cdn.shopify.com/s/files/1/0679/4461/2161/files/22.png?v=1763120749" loading="lazy" class="size-chart__image" alt="22 inch chain on broad neck">
          </div>
          <div class="size-chart__image-wrapper" data-length='24"' data-neck="Broad" data-description="Best for layering with other chains">
            <img src="https://cdn.shopify.com/s/files/1/0679/4461/2161/files/24.png?v=1763120747" loading="lazy" class="size-chart__image" alt="24 inch chain on broad neck">
          </div>
        </div>
        <div class="size-chart__neck-sizes">
          <button type="button" class="size-chart__neck-btn is-active" data-role="neck-btn" data-neck="Thin">
            <span class="size-chart__neck-label">Thin</span>
            <span class="size-chart__neck-sublabel">Neck Size</span>
          </button>
          <button type="button" class="size-chart__neck-btn" data-role="neck-btn" data-neck="Broad">
            <span class="size-chart__neck-label">Broad</span>
            <span class="size-chart__neck-sublabel">Neck Size</span>
          </button>
        </div>
      </div>
    `;
  }

  function getBraceletsChartHTML() {
    return `
      <div class="size-chart--bracelets">
        <div class="size-chart__heading">
          <button class="size-chart__close" data-size-chart-close aria-label="Close">&#x2715;</button>
          <div class="size-chart__header-text">How to Measure Your Wrist</div>
        </div>
        <div class="size-chart__description rte">
          <p>Wrap a measuring tape, string, or phone charger around your wrist where you wear a bracelet. Mark where the ends meet and measure it.</p>
          <div class="size-chart__section-header-text">Choose Your Bracelet Size</div>
          <p>Select a bracelet that's <strong>0.2–0.4 inches (0.5–1 cm)</strong> larger than your wrist for a comfortable fit.</p>
          <div class="size-chart__section-header-text">Example</div>
          <p>If your wrist measures 7 inches (18 cm), choose a 7" or 8" bracelet depending on fit:</p>
          <ul><li>7" = snug</li><li>8" = relaxed</li></ul>
        </div>
        <div class="size-chart__table-header-text">Bracelet Size Guide</div>
        <table class="size-chart__table">
          <thead><tr><th class="size-chart__th">Bracelet Length</th><th class="size-chart__th">Wrist Circumference</th></tr></thead>
          <tbody>
            <tr><td>6" (15.2 cm)</td><td>5.5 – 6.0" (14.0 – 15.2 cm)</td></tr>
            <tr><td>7" (17.8 cm)</td><td>6.5 – 7.0" (16.5 – 17.8 cm)</td></tr>
            <tr><td>8" (20.3 cm)</td><td>7.5 – 8.0" (19.0 – 20.3 cm)</td></tr>
            <tr><td>9" (22.9 cm)</td><td>8.5 – 9.0" (21.6 – 22.9 cm)</td></tr>
            <tr><td>10" (25.4 cm)</td><td>9.5 – 10.0" (24.1 – 25.4 cm)</td></tr>
          </tbody>
        </table>
      </div>
    `;
  }

  // Add similar functions for rings, earrings, watches, grillz...
  function getRingsChartHTML() { return '<div class="size-chart--rings"><!-- Rings content --></div>'; }
  function getEarringsChartHTML() { return '<div class="size-chart--earrings"><!-- Earrings content --></div>'; }
  function getWatchesChartHTML() { return '<div class="size-chart--watches"><!-- Watches content --></div>'; }
  function getGrillzChartHTML() { return '<div class="size-chart--grillz"><!-- Grillz content --></div>'; }

  // Handle size chart triggers from BOTH product page AND cart drawer
  document.addEventListener('click', function(e) {
    const trigger = e.target.closest('[data-size-chart-trigger], .main-product__size-charts button, .cd-size-chart-trigger');
    
    if (trigger) {
      e.preventDefault();
      e.stopPropagation();
      
      // Get product tags from trigger button (cart drawer) or leave empty (product page)
      const productTags = trigger.dataset.productTags || '';
      
      openPopup(productTags);
    }
  });

  // Close handlers
  const closeElements = popup.querySelectorAll('[data-size-chart-close]');
  closeElements.forEach(el => {
    el.addEventListener('click', closePopup);
  });

  // Use event delegation for dynamically added close buttons
  popup.addEventListener('click', function(e) {
    if (e.target.matches('[data-size-chart-close]')) {
      closePopup();
    }
  });

  document.addEventListener('keydown', function(e) {
    if (e.key === 'Escape' && !popup.classList.contains('hidden')) {
      closePopup();
    }
  });
});